import { ElementRef, Injectable } from '@angular/core';

@Injectable()
export class ElementHelperService {
   constructor() { }

  isElementVisible(elm : ElementRef){

    let displayValue = elm.nativeElement.getAttribute('display');

    console.log('isElementVisible.displayValue',displayValue,elm);
  }
  
  isWithinView(el:any){
    var rect = el.getBoundingClientRect(), top = rect.top, height = rect.height, 
    el = el.parentNode

    console.log('isWithinView.rect',rect);

    console.log('isWithinView.rect.bottom',rect.bottom);
    console.log('isWithinView.rect.top',rect.top);
    console.log('isWithinView.rect.height',rect.height);
  // Check if bottom of the element is off the page
  if (rect.bottom < 0){

    console.log(`Returned false because elements bottom value is less than zero. Actual value: ${rect.bottom}`);
    return false;
  } 

  // Check its within the document viewport
  if (top > document.documentElement.clientHeight){

    console.log(`Returned false because element's top value is greature than the document client height. Actual top value: ${rect.top}, Actual client height: ${document.documentElement.clientHeight}`);

  return false;  } 
  do {
    rect = el.getBoundingClientRect()
    if (top <= rect.bottom === false) return false
    // Check if the element is out of view due to a container scrolling
    if ((top + height) <= rect.top) return false
    el = el.parentNode
  } while (el != document.body)
  return true    
  }




}
